<template>
	<v-dialog
		v-model="dialog"
		max-width="500"
	>
		<v-card>
			<v-toolbar dark flat color="primary" class="text-uppercase">
				<v-spacer/>
				{{$T('sync-queue.title')}}
				<v-spacer/>
				<v-toolbar-items text>
					<v-btn small text @click="dialog=false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar-items>
			</v-toolbar>

			<v-card-text class="pt-4">
				<div v-if="!queue.length" class="text-center text-body-2 py-4">
					{{$T('sync-queue.empty')}}
				</div>

				<v-list v-else two-line>
					<v-list-item v-for="item in queue" :key="item.localId">
						<v-list-item-content>
							<v-list-item-title>
								{{ getEntityById(item.visitPayload.entityId) ? getEntityById(item.visitPayload.entityId).name : '' }}
							</v-list-item-title>
							<v-list-item-subtitle>
								{{ moment(item.visitPayload.createdAt).format('YYYY-MM-DD HH:mm') }}
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="item.status === 'error'" class="error--text">
								{{$T('sync-queue.error')}}: {{ item.errorMessage }}
							</v-list-item-subtitle>
							<v-list-item-subtitle v-else>
								{{$T('sync-queue.pending')}}
							</v-list-item-subtitle>
						</v-list-item-content>

						<v-list-item-action>
							<v-btn icon @click="remove(item.localId)">
								<v-icon color="error" size="20">mdi-delete</v-icon>
							</v-btn>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-card-text>

			<v-card-actions>
				<v-spacer/>
				<v-btn
					color="primary"
					text
					:loading="isSyncing"
					:disabled="isSyncing || !queue.length"
					@click="syncNow"
				>
					{{$T('sync-queue.sync-now')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
	data() {
		return {
			dialog: false,
			moment,
		}
	},

	computed: {
		...mapState({
			queue: state => state.sync.queue,
			isSyncing: state => state.sync.isSyncing,
		}),

		...mapGetters({
			getEntityById: 'entities/getEntityById',
		})
	},

	methods: {
		open() {
			this.dialog = true;
		},

		syncNow() {
			this.$store.dispatch('sync/flushQueue');
		},

		remove(localId) {
			if (!window.confirm(this.$T('sync-queue.delete-confirm'))) return;
			this.$store.dispatch('sync/removeFromQueue', { localId });
		}
	}
}
</script>
